import { render, staticRenderFns } from "./doughnutChart.vue?vue&type=template&id=271ee05c&scoped=true"
import script from "./doughnutChart.vue?vue&type=script&lang=js"
export * from "./doughnutChart.vue?vue&type=script&lang=js"
import style0 from "./doughnutChart.vue?vue&type=style&index=0&id=271ee05c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271ee05c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/check/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('271ee05c')) {
      api.createRecord('271ee05c', component.options)
    } else {
      api.reload('271ee05c', component.options)
    }
    module.hot.accept("./doughnutChart.vue?vue&type=template&id=271ee05c&scoped=true", function () {
      api.rerender('271ee05c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/doughnutChart.vue"
export default component.exports